import React, { FC } from 'react'

const ChatLauncherIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width={24}
        height={22}
        viewBox="0 0 24 22"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="chat-launcher-icon"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.26745 21.3362C4.05904 21.3163 3.85245 21.2882 3.6486 21.2524C3.34217 21.1985 3.08836 20.988 2.98297 20.7003C2.87758 20.4126 2.93664 20.0915 3.13788 19.8582C3.60592 19.3156 3.93745 18.6582 4.08329 17.936C4.10982 17.8047 4.05717 17.575 3.78793 17.3176C1.87412 15.4878 0.685059 13.0045 0.685059 10.259C0.685059 4.52461 5.8238 0 12.0001 0C18.1763 0 23.3151 4.52461 23.3151 10.259C23.3151 15.9934 18.1763 20.518 12.0001 20.518C11.0331 20.518 10.0932 20.4079 9.19529 20.2003C7.98987 20.9433 6.5634 21.3729 5.03698 21.3729C4.77757 21.3729 4.52074 21.3605 4.26745 21.3362Z"
            fill="url(#paint0_linear_1951_13820)"
        />
        <g filter="url(#filter0_d_1951_13820)">
            <path
                d="M7.50098 13.1112V15.8044H11.7308C15.7072 15.8044 18.036 13.4439 18.036 10.2279V10.1962C18.036 6.98028 15.7389 4.71484 11.7942 4.71484H7.50098V7.408L9.51181 7.40801L11.8576 7.40802C13.7111 7.40802 14.8993 8.4536 14.8993 10.2438V10.2755C14.8993 12.0656 13.7111 13.1112 11.8576 13.1112L7.50098 13.1112Z"
                fill="white"
            />
            <path
                d="M7.50098 12.7943H10.5744V7.72484H7.50098V12.7943Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1951_13820"
                x={4.50096}
                y={4.71484}
                width={16.5352}
                height={17.0899}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={3.00002} />
                <feGaussianBlur stdDeviation={1.50001} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1951_13820"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1951_13820"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_1951_13820"
                x1={4.92818}
                y1={-4.25192e-7}
                x2={21.3346}
                y2={18.2226}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.00436076} stopColor="#1EF2FF" />
                <stop offset={0.51} stopColor="#7133FF" />
                <stop offset={0.904041} stopColor="#CD21FF" />
            </linearGradient>
        </defs>
    </svg>
)
export default ChatLauncherIcon
